function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackArrow = function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fill: "none",
    d: "M19 12H5M12 19l-7-7 7-7"
  }));
};
export default SvgBackArrow;